import {
  DownOutlined
} from '@ant-design/icons';
import {
  Col,
  Tree,
  TreeDataNode
} from 'antd';
import { Key, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface TreeDataProps {
  treeData: TreeDataNode[] | undefined;
  keySelectDefault: Key;
  onSelectTree: (selectedKeys: Key[], info: any) => void;
}

function LocationTree(props: TreeDataProps) {
  const { t } = useTranslation();
  const [selectedKeys, setSelectedKeys] = useState<Key[]>([props.keySelectDefault]);

  useEffect(() => {
    if(props.treeData){
      setSelectedKeys([props.keySelectDefault]);
    }
  }, [props.keySelectDefault, props.treeData]);

  useEffect(() => {
    props.onSelectTree([props.keySelectDefault], null);
  }, [props.keySelectDefault]);

  const handlerSelectedFilter = (selectedKeys: React.Key[], info: any) => {
    setSelectedKeys(selectedKeys);
    props.onSelectTree(selectedKeys, info);  
  };

  return (
      <Col className="location-tree" span={24}>
        <Tree
          selectedKeys={selectedKeys}
          showLine={true}
          showIcon={true}
          onSelect={handlerSelectedFilter}
          switcherIcon={<DownOutlined />}
          treeData={props.treeData}
        />
      </Col>
  );
}
export default LocationTree;
